import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sale-skupina',
  templateUrl: './sale-skupina.component.html',
  styleUrls: ['./sale-skupina.component.css']
})
export class SaleSkupinaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    //SALE_DATE_IGRO_01
  }

}
